var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('div',{staticClass:"overlay",attrs:{"role":"status","aria-live":"polite","aria-busy":"true"}},[_c('div',{staticClass:"dots-loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }